import { Component, effect, EventEmitter, Input, Output } from '@angular/core';
import { AgentVoiceComponent } from "./components/agent-voice/agent-voice.component";
import { AgentKeyboardComponent } from './components/agent-keyboard/agent-keyboard.component';
import { CommonModule } from '@angular/common';
import { SvgLoaderComponent } from "app/components/ui-kit/images/svg-loader/svg-loader.component";
import { DeviceService } from 'app/services/device.service';
import { AppStateService } from 'app/services/app-state.service';
import { PopTrayComponent } from 'app/components/ui-kit/popovers/pop-tray/pop-tray.component';

@Component({
  selector: 'app-agent-conversation-inputs',
  standalone: true,
  imports: [AgentVoiceComponent, AgentKeyboardComponent, CommonModule, SvgLoaderComponent, PopTrayComponent],
  templateUrl: './agent-conversation-inputs.component.html',
  styleUrl: './agent-conversation-inputs.component.scss'
})
export class AgentConversationInputsComponent {
  @Output() handleCreateNewConvo = new EventEmitter<string>();

  isMobile: boolean = false;
  isKeyboard: boolean = true;
  isKeyboardFocused: boolean = false;

  showConfirmNewConvo: boolean = false;
  confirmationTrayActions: any;

  constructor(private deviceService: DeviceService, public appState: AppStateService) {
    this.confirmationTrayActions = {
      primaryButtons: [
        {
          text: 'Yes',
          function: () => this.onClickConfirmNewConvo(),
        }
      ],
      secondaryButtons: [
        {
          text: 'Cancel',
          function: () => this.onClickCancelNewConvo(),
        }
      ],
      closeFunction: () => this.onClickCancelNewConvo()
    };
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.getDeviceType() === 'mobile';
    const storedPreference = localStorage.getItem('isKeyboard');
    if (storedPreference !== null) {
      this.isKeyboard = storedPreference === 'true';
      this.appState.agent.ioMethod.set(this.isKeyboard ? 'keyboard' : 'voice');
    } else {
      localStorage.setItem('isKeyboard', 'true');
    }
  }

  handleKeyboardFocus(status): void {
    if (status === true) {
      this.isKeyboardFocused = status;
      this.appState.device.isKeyboardFocused.set(true);
    } else {
      setTimeout(() => {
        this.isKeyboardFocused = status;
        this.appState.device.isKeyboardFocused.set(false); // TODO: align all with appState
      }, 400);
    }
  }

  onToggleInputType(): void {
    if (this.isKeyboard) {
      this.isKeyboard = false;
      this.appState.agent.ioMethod.set('voice');
    } else {
      this.isKeyboard = true;
      this.appState.agent.ioMethod.set('keyboard');
    }
    localStorage.setItem('isKeyboard', this.isKeyboard.toString());
  }

  onClickNewConvo(): void {
    this.showConfirmNewConvo = true;
  }

  onClickConfirmNewConvo(): void {
    this.handleCreateNewConvo.emit();
  }

  onClickCancelNewConvo(): void {
    this.showConfirmNewConvo = false;
  }

  onClickDismissActions(): void {
    this.appState.agent.isNoResult.set(false);
    this.appState.agent.refinedFlightOptions.set([]);
  }

}
